import styled from "styled-components";
import { addIcon } from "@mixins";
export var HeaderBlock = styled.header.withConfig({
  displayName: "headerblockstyles__HeaderBlock",
  componentId: "sc-1yj87n6-0"
})(["", ""], function (_ref) {
  var theme = _ref.theme;
  return "\n    display: flex;\n    padding: ".concat(theme.space.sm, ";\n    background: ").concat(theme.colors.P3, ";\n\n    @media (max-width: ").concat(theme.breakpoints[2], "){\n      padding: ").concat(theme.space.xs, ";\n    }\n  ");
});
export var SoughtValue = styled.p.withConfig({
  displayName: "headerblockstyles__SoughtValue",
  componentId: "sc-1yj87n6-1"
})(["&:before{", "}", ""], function (_ref2) {
  var theme = _ref2.theme,
    soughtValue = _ref2.soughtValue;
  return soughtValue === "Högt" ? addIcon(theme, "trendUp", "auto 10px auto 0") : addIcon(theme, "trendDown", "auto 10px auto 0");
}, function (_ref3) {
  var theme = _ref3.theme;
  return "\n    font-family: ".concat(theme.fonts.robotoRegular, ";\n    font-size: ").concat(theme.fontSizes.sm, ";\n    color: ").concat(theme.colors.G1, ";\n    margin: 0;\n  ");
});